<dx-bar-gauge class="gauge"
  [palette]="palette"
  [startValue]="startValue"
  [endValue]="endValue"
  [values]="values">
  <dxo-label [visible]="showLabel"></dxo-label>
  <dxo-tooltip [enabled]="showTooltip"></dxo-tooltip>
  <dxo-geometry [startAngle]="180" [endAngle]="0"></dxo-geometry>
</dx-bar-gauge>
